class CartDrawerFreeGift extends HTMLElement {
  connectedCallback() {
    const button = this.querySelector('[data-free-gift-add]');
    if (!button) return;
    button.addEventListener('click', () => this.addToCart(button));
  }

  async addToCart(button) {
    if (button.disabled) return;
    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = 'Adding…';

    try {
      const response = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(this.dataset.variantId, 10), quantity: 1 }] }),
      });

      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.description || 'Could not add free gift to cart');
      }

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function' && !cartDrawer.classList.contains('active')) {
        cartDrawer.open();
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-free-gift' });
      }
      // Publishing cartUpdate causes cart-drawer-items (which this element lives
      // inside) to be refetched and replaced wholesale, so this card will simply
      // disappear once the gift is in the cart -- no manual UI reset needed here.
    } catch (error) {
      console.error('[cart-drawer-free-gift]', error);
      button.textContent = 'Try again';
      button.disabled = false;
      setTimeout(() => {
        button.textContent = originalText;
      }, 2000);
    }
  }
}

customElements.define('cart-drawer-free-gift', CartDrawerFreeGift);
